/**
 * Feito pelo agente netexperts
 * Módulo: AnalyticsObra — estados de loading/erro/vazio das tabs
 * Data: 2026-06-14
 */
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const TabState = ({ loading, error }) => (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-12 flex flex-col items-center justify-center text-center">
        {loading && (
            <>
                <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-900 rounded-full animate-spin mb-3" />
                <p className="text-sm text-gray-500">Carregando dados agregados…</p>
            </>
        )}
        {!loading && error && (
            <>
                <ExclamationTriangleIcon className="w-8 h-8 text-amber-500 mb-3" />
                <p className="text-sm text-gray-600">Não foi possível carregar os dados desta área.</p>
            </>
        )}
        {!loading && !error && (
            <p className="text-sm text-gray-400">Sem dados disponíveis.</p>
        )}
    </div>
)

export default TabState
